<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="px-3 py-2">
    <div
      class="flex w-full items-center gap-1 rounded-xl border border-n-weak bg-n-solid-2 p-1 lg:max-w-xl dark:border-n-strong"
      role="tablist"
    >
      <button
        v-for="(item, index) in items"
        :key="item.key"
        type="button"
        role="tab"
        :aria-selected="index === activeTabIndex"
        class="reset-base m-0 inline-flex h-8 min-w-0 flex-1 items-center justify-center gap-1.5 rounded-lg px-2 py-0 text-xs font-semibold leading-none transition-[background-color,color,box-shadow] duration-200 !translate-y-0"
        :class="
          index === activeTabIndex
            ? 'bg-n-solid-1 text-n-slate-12 shadow-sm ring-1 ring-n-weak'
            : 'text-n-slate-11 hover:bg-n-alpha-1 hover:text-n-slate-12'
        "
        @click="onTabChange(index)"
      >
        <span class="truncate">{{ item.name }}</span>
        <span
          class="inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-md px-1.5 text-[11px] tabular-nums"
          :class="
            index === activeTabIndex
              ? 'bg-n-brand text-white'
              : 'bg-n-alpha-2 text-n-slate-11'
          "
        >
          {{ item.count }}
        </span>
      </button>
    </div>
  </div>
</template>
